export default function () {

    const newsflash = document.getElementById('newsflash');
    if(newsflash) {
        const close = newsflash.querySelector('.newsflash__close');
        close.addEventListener('click', (e) => {
            setCookie("itp_newsflash", 1, 0);
            newsflash.classList.add('hidden');
        });
    }

}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + (days === 0 ? "" : date.toUTCString());
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
